<template>
  <div>
    <h3 class="mt-3">
      {{ $t("SummaryTable.characteristics") }}
    </h3>
    <table class="table table-striped table-sm mb-4">
      <tbody>
        <tr
          v-for="(val, key) in summary"
          :key="key"
        >
          <th scope="row">
            {{ $t(`SummaryTable.${key}`) }}
          </th>
          <td
            v-if="key === 'status'"
            class="pill"
          >
            <span
              class="badge"
              :class="'badge-' + status.variant"
            >
              <i :class="status.icon" />
              <span class="ml-1 pr-1">{{ val }}</span>
            </span>
            <i
              v-if="hasAssessment && ! hasRealisationProcess && isAllowedToEditAssessment"
              class="fa-fw fal fa-pen-to-square ml-1 start-editing-assessment"
              @click="resetAssessment"
            />
          </td>
          <td v-else-if="key === 'address'">
            {{ val }}
            <br>
            <a
              target="_blank"
              :href="`https://www.google.com/maps/search/?api=1&amp;query=${encodeURIComponent(val)}`"
            >
              {{ $t("SummaryTable.openMaps") }} <i class="icon fa-fw fal fa-arrow-up-right-from-square" />
            </a>
          </td>
          <td v-else>
            {{ val }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SummaryTable',
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRole']),
    ...mapGetters('requests', ['statusOptionById']),
    ...mapGetters('relations', ['realisationUuidByRequestUuid']),
    status() {
      return this.statusOptionById({ id: this.request.status })
    },
    hasAssessment() {
      return this.status.id !== 2
    },
    isRejected() {
      return this.status.id === 4
    },
    hasRealisationProcess() {
      return !!this.request.connectedProcess
    },
    isAllowedToEditAssessment() {
      return this.hasRole({ role: 'admin' })
    },
    summary() {
      const summary = {
        reference: this.request.case_ref,
        origin: this.request.origin,
        status: this.status.name,
        submitted_at: this.request.submitted_at,
      }

      if (this.hasAssessment) {
        summary.evaluated = this.request.processed_at
      }

      if (this.isRejected) {
        summary.reason = this.request.assessment.reasonLabel?.[this.$i18n.locale] || this.request.assessment.reasonLabel

        if (this.request.assessment.reason === 3) {
          summary.remark = this.request.assessment.remarks
        }
      }

      return Object.assign(summary, {
        applicant: this.request.summary.name,
        address: this.request.summary.address,
      })
    },
  },
  methods: {
    resetAssessment() {
      this.$emit('assessmentMode', { mode: true })
    },
  },
}
</script>

<style lang="scss">
.pill,
.pill .badge {
  display: flex;
  align-items: center;
}

.start-editing-assessment {
  &:hover {
    cursor: pointer;
  }
}
</style>
